import './MobileTopBar.css';
import { mediaUrl } from './config';
import { IconHeadphones, IconClock, IconShoppingBag2, IconHome, IconZap, IconFootprint, IconLaptop, IconTag, IconBag, IconFlame, IconMapPin } from './Icons';
import { formatCurrency } from './currency';
import { productLinkId } from './productPath';

const CATEGORY_ICONS = {
  Audio: IconHeadphones,
  Wearables: IconClock,
  Accessories: IconShoppingBag2,
  Home: IconHome,
  Fitness: IconZap,
  Shoes: IconFootprint,
  Electronics: IconLaptop,
  Clothing: IconTag,
};
const iconFor = (cat) => CATEGORY_ICONS[cat] || IconBag;

export default function MobileTopBar({
  savedAddress,
  onOpenAddress,
  categories,
  selectedCategory,
  dealsOnly,
  onSelectCategory,
  onSelectDeals,
  recentlyViewedProducts,
  userName,
  onProductClick,
}) {
  const addressLabel = savedAddress
    ? `${savedAddress.addressLine1}, ${savedAddress.city}`
    : 'Add a delivery address';

  return (
    <div className="mtb-wrap">
      <button className="mtb-delivery-row" onClick={onOpenAddress}>
        <span className="mtb-delivery-icon" aria-hidden="true"><IconMapPin size={16} /></span>
        <span className="mtb-delivery-text">
          <span className="mtb-delivery-label">Deliver to</span>
          <span className="mtb-delivery-value">{addressLabel}</span>
        </span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      <nav className="mtb-cat-strip" aria-label="Categories">
        <button
          className={`mtb-cat-tile${selectedCategory === 'All' && !dealsOnly ? ' active' : ''}`}
          onClick={() => onSelectCategory('All')}
        >
          <span className="mtb-cat-icon"><IconBag size={20} /></span>
          <span className="mtb-cat-label">For You</span>
        </button>
        <button
          className={`mtb-cat-tile${dealsOnly ? ' active' : ''}`}
          onClick={onSelectDeals}
        >
          <span className="mtb-cat-icon"><IconFlame size={20} /></span>
          <span className="mtb-cat-label">Deals</span>
        </button>
        {categories.filter(c => c !== 'All').map(cat => (
          <button
            key={cat}
            className={`mtb-cat-tile${selectedCategory === cat && !dealsOnly ? ' active' : ''}`}
            onClick={() => onSelectCategory(cat)}
          >
            <span className="mtb-cat-icon">{(() => { const CatIcon = iconFor(cat); return <CatIcon size={20} />; })()}</span>
            <span className="mtb-cat-label">{cat}</span>
          </button>
        ))}
      </nav>

      {recentlyViewedProducts.length > 0 && (
        <div className="mtb-recent">
          <h3 className="mtb-recent-title">
            <IconClock size={14} /> {userName ? `${userName}, still looking for these?` : 'Still looking for these?'}
          </h3>
          <div className="mtb-recent-strip">
            {recentlyViewedProducts.map(p => (
              <button key={p.id} className="mtb-recent-card" onClick={() => onProductClick(productLinkId(p))}>
                <span className="mtb-recent-img-wrap">
                  <img src={mediaUrl(p.image)} alt={p.name} className="mtb-recent-img" />
                </span>
                <span className="mtb-recent-name">{p.name}</span>
                <span className="mtb-recent-price">{formatCurrency(p.price)}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
